import { useTranslation } from 'react-i18next';
import { Box, styled, useTheme } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import { AgathaMessageContainer } from './StyledComponents';
import { RelatedArticlesTranscriptComponent } from './types';

export const RelatedArticles = ({
  isAssist,
  transcriptComponent,
}: {
  isAssist?: boolean;
  transcriptComponent: RelatedArticlesTranscriptComponent;
}) => {
  const { t } = useTranslation('intent-conversation-analytics');
  const theme = useTheme();

  if (transcriptComponent.articles.length === 0) {
    return null;
  }

  if (isAssist) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        {transcriptComponent.articles.map(article => {
          return (
            <Box
              key={article.document_id}
              sx={{
                alignItems: 'center',
                border: `1px solid ${theme.palette.colors.slate[200]}`,
                borderRadius: '24px',
                display: 'flex',
                gap: '4px',
                p: '8px 16px',
              }}
            >
              <Box sx={{ flexShrink: 0, minWidth: 55, width: 55 }}>
                <Typography
                  color={theme.palette.colors.grey[600]}
                  variant='font14'
                >
                  {t('relatedArticles.source')}
                </Typography>
              </Box>
              <StyledArticleLink
                href={article.link}
                rel='noreferrer'
                target='_blank'
              >
                {article.title}
              </StyledArticleLink>
            </Box>
          );
        })}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
      }}
    >
      <Box
        sx={{
          mb: '8px',
        }}
      >
        <Typography variant='font14'>{t('relatedArticles.sources')}</Typography>
      </Box>
      {transcriptComponent.articles
        .filter(article => Boolean(article.link))
        .map(article => {
          return (
            <AgathaMessageContainer
              backgroundColor={theme.palette.colors.slate[100]}
              key={article.document_id}
            >
              <StyledArticleLink
                href={article.link}
                rel='noreferrer'
                target='_blank'
              >
                {article.title}
              </StyledArticleLink>
            </AgathaMessageContainer>
          );
        })}
    </Box>
  );
};

const StyledArticleLink = styled('a')`
  color: ${props => props.theme.palette.colors.black};
  font-size: 14px;
  display: block;
  text-align: initial;
  text-decoration: underline;
  cursor: pointer;
  padding-bottom: 0;
  background-color: transparent;
  border: none;
  padding: 0;
  margin-top: 0;
`;
